import { useState } from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalHeader from '@/components/modal/ModalHeader.tsx';
import ModalContent from '@/components/modal/ModalContent.tsx';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/Tabs.tsx';
import { TfgDeklaracjaPreviewDto } from '@/features/dashboard/tfg/types/TfgDeklaracjaPreviewDto.ts';
import { getMonthLabel } from '@/features/dashboard/tfg/types/month.ts';
import DeklaracjaSectionI from '@/features/dashboard/tfg/components/DeklaracjaSectionI.tsx';
import DeklaracjaSectionII from '@/features/dashboard/tfg/components/DeklaracjaSectionII.tsx';

enum PreviewTab {
  TFG = 'TFG',
  TFP = 'TFP',
}

interface DeklaracjaPreviewModalProps {
  data: TfgDeklaracjaPreviewDto;
  onClose: () => void;
}

const DeklaracjaPreviewModal = ({
  data,
  onClose,
}: DeklaracjaPreviewModalProps) => {
  const [tab, setTab] = useState<PreviewTab>(PreviewTab.TFG);

  return (
    <Modal onClose={onClose} className="max-w-[1100px]">
      <ModalHeader
        title={`Deklaracja TFG — ${getMonthLabel(data.month)} ${data.year}`}
        onClose={onClose}
      />
      <ModalContent>
        <Tabs value={tab} onValueChange={(value) => setTab(value as PreviewTab)}>
          <TabsList>
            <TabsTrigger value={PreviewTab.TFG}>TFG</TabsTrigger>
            <TabsTrigger value={PreviewTab.TFP}>TFP</TabsTrigger>
          </TabsList>
          <TabsContent value={PreviewTab.TFG}>
            <div className="space-y-8">
              <DeklaracjaSectionI rows={data.sectionI} total={data.field60} />
              <DeklaracjaSectionII rows={data.sectionII} total={data.field97} />
            </div>
          </TabsContent>
          <TabsContent value={PreviewTab.TFP}>
            <div className="space-y-8">
              <DeklaracjaSectionI
                rows={data.tfp.sectionI}
                total={data.tfp.field60}
              />
              <DeklaracjaSectionII
                rows={data.tfp.sectionII}
                total={data.tfp.field97}
              />
            </div>
          </TabsContent>
        </Tabs>
      </ModalContent>
    </Modal>
  );
};

export default DeklaracjaPreviewModal;
